module.exports = __webpack_public_path__ + "img/Rotation4.841a613b.jpg";